@if (title(); as title){
  <div class="soft-overline !mb-2">{{ title }}</div>
}
<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-4 ">
  <ng-content></ng-content>
</div>
